<template>
  <b-card v-if="cidadao" class="shadow-sm mb-3 header-card">
    <div class="d-flex flex-wrap align-items-center justify-content-between">
      <div class="d-flex align-items-start">
        <div class="mr-3 bubble-logo d-none d-sm-flex">
          <span><i class="icofont-user"></i></span>
        </div>
        <div>
          <div class="h5 mb-1">
            <strong>{{ cidadao.no_cidadao }}</strong> | {{ cidadao.sexo }} |
            <span
              class="header-card-info-span font-weight-bold"
              :class="
                situacaoCadastro() == 'Óbito' ||
                situacaoCadastro() == 'Desatualizado'
                  ? 'red'
                  : 'green'
              "
            >
              {{ situacaoCadastro() }}
            </span>
          </div>
          <div class="small text-muted">
            <strong>CPF:</strong> {{ cidadao.nu_cpf }} ·
            <strong>Cad. atualizado em</strong>
            {{
              cidadao.dt_ultima_ficha != null
                ? formatDate(cidadao.dt_ultima_ficha)
                : ''
            }}
            · <strong> Acompanhado em</strong>
            {{
              cidadao.dt_ultimo_acompanhamento != null
                ? formatDate(cidadao.dt_ultimo_acompanhamento)
                : ''
            }}
            ·
            <span class="font-weight-bold">{{
              cidadao.tp_ultimo_acompanhamento
            }}</span>
          </div>
        </div>
      </div>
      <div v-if="cidadao.nu_cpf != null || cidadao.nu_cns != null">
        <b-button type="button" class="btn-imprimir-cns" @click="imprimirCNS">
          <i class="icofont icofont-card mr-2"></i>
          Imprimir CNS
        </b-button>
      </div>
    </div>
    <hr />
    <div class="d-flex align-items-center justify-content-between mt-4">
      <div>
        <b-form-checkbox-group
          v-model="selectedValues"
          name="filtros_unico"
          class="d-flex flex-wrap filtros-check"
          @input="onCheckboxGroupInput"
        >
          <b-form-checkbox
            v-for="opt in filterOptions"
            :key="opt.value"
            :value="opt.value"
            :disabled="bloquearFiltros || opcoesBloqueadas.includes(opt.value)"
          >
            {{ opt.text }}
          </b-form-checkbox>
        </b-form-checkbox-group>
      </div>

      <div class="d-flex align-items-center">
        <span class="mr-2">Data</span>

        <b-form-select
          v-model="atendimentoOperador"
          :options="operadores"
          class="mr-2"
          style="max-width: 90px"
          :disabled="bloquearFiltros"
        />

        <b-form-input
          type="date"
          v-model="atendimentoData"
          :disabled="bloquearFiltros"
          style="min-width: 180px"
        />
      </div>
    </div>
  </b-card>
</template>

<script>
import utils from '@/mixins/utils.js'
import { jsPDF } from 'jspdf'
import JsBarcode from 'jsbarcode'
import templateCartao from '@/assets/images/template-cartao-cns.png'

export default {
  name: 'InfoCidadao',
  props: {
    cidadao: {
      type: Object,
      default: null,
    },
    activeKey: {
      type: String,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      filterOptions: [
        { text: 'Mais acesso', value: 'mais-acesso' },
        { text: 'Criança', value: 'crianca' },
        { text: 'Mulher', value: 'mulher' },
        { text: 'Hipertensão', value: 'hipertensao' },
        { text: 'Diabetes', value: 'diabetes' },
        { text: 'Pessoa idosa', value: 'idosa' },
        { text: 'Gestante', value: 'gestante' },
        { text: 'Puérpera', value: 'puerpera' },
      ],
      selectedFilter: null,
      selectedValues: [],
      opcoesBloqueadas: [],
      operadores: [
        { text: '>', value: '>' },
        { text: '<', value: '<' },
        { text: '>=', value: '>=' },
        { text: '<=', value: '<=' },
        { text: '=', value: '=' },
      ],
      atendimentoOperador: '>=',
      atendimentoData: '',
      regraDiasPorFiltro: {
        'mais-acesso': 365,
        crianca: 730,
        mulher: 365,
        hipertensao: 182,
        diabetes: 182,
        idosa: 365,
        gestante: 365,
        puerpera: 365,
      },
    }
  },
  watch: {
    cidadao: {
      handler() {
        this.aplicarFiltroPorPendencias()
      },
      immediate: true,
    },

    selectedFilter: {
      handler() {
        this.atualizarDataAtendimentoPorFiltro()
        this.emitirFiltro()
      },
      immediate: true,
    },

    selectedValues(val) {
      if (val.length === 0) {
        this.selectedFilter = null
        return
      }

      // garante só 1 selecionado (último clicado)
      const last = val[val.length - 1]
      if (val.length > 1) {
        this.selectedValues = [last]
      }
      this.selectedFilter = last
    },

    atendimentoOperador() {
      this.emitirFiltro()
    },

    atendimentoData() {
      this.emitirFiltro()
    },

    activeKey(val) {
      if (['historico', 'duplicados', 'unificacoes'].includes(val)) {
        this.selectedValues = []
        this.selectedFilter = null
        this.atendimentoOperador = '>='
        this.atendimentoData = ''
        this.opcoesBloqueadas = this.filterOptions.map((o) => o.value)
        this.emitirFiltro()
      } else {
        this.opcoesBloqueadas = []
        this.aplicarFiltroPorPendencias()
        this.emitirFiltro()
      }
    },
  },
  computed: {
    bloquearFiltros() {
      return ['historico', 'duplicados', 'unificacoes'].includes(this.activeKey)
    },
  },
  methods: {
    /**
     * Mantém apenas um filtro selecionado no grupo de checkboxes.
     * @param {Array} arr Valores selecionados
     */
    onCheckboxGroupInput(arr) {
      // Se marcou algo - mantém apenas o último
      // Se desmarcou o único - libera todos
      this.selectedFilter = arr.length ? arr[0] : null
    },

    /**
     * Aplica o filtro com base nas pendências críticas do cidadão.
     */
    aplicarFiltroPorPendencias() {
      this.opcoesBloqueadas = []
      this.selectedFilter = null
      this.selectedValues = []

      const pend =
        this.cidadao &&
        this.cidadao.pendencias_criticas &&
        this.cidadao.pendencias_criticas.pendencia_8

      if (!Array.isArray(pend) || pend.length === 0) {
        return
      }

      const mapaIndicadorFiltro = {
        C1: 'mais-acesso',
        C2: 'crianca',
        C3G: 'gestante',
        C3P: 'puerpera',
        C4: 'diabetes',
        C5: 'hipertensao',
        C6: 'idosa',
        C7: 'mulher',
      }

      const filtrosDasPendencias = []

      for (const item of pend) {
        const ind = item && item.indicador
        const filtro = mapaIndicadorFiltro[ind]
        if (filtro && !filtrosDasPendencias.includes(filtro)) {
          filtrosDasPendencias.push(filtro)
        }
      }

      if (filtrosDasPendencias.length === 0) {
        return
      }

      // pré-seleciona a primeira que veio de pendência
      this.selectedFilter = filtrosDasPendencias[0]
      this.selectedValues = [this.selectedFilter]

      // bloqueia todas as outras
      const todasAsOpcoes = this.filterOptions.map((o) => o.value)
      this.opcoesBloqueadas = todasAsOpcoes.filter(
        (value) => !filtrosDasPendencias.includes(value)
      )
    },

    /**
     * Atualiza a data de atendimento conforme o filtro selecionado.
     */
    atualizarDataAtendimentoPorFiltro() {
      if (!this.selectedFilter) {
        this.atendimentoData = ''
        return
      }

      if (
        this.activeKey == 'atendimentos' &&
        (this.selectedFilter == 'hipertensao' ||
          this.selectedFilter == 'diabetes')
      ) {
        this.atendimentoData = this.dtUltimoRegistroIdSinc(49)
        return
      }

      const { data_fim } = this.datasQuadrimestre()
      const fim = new Date(`${data_fim}T00:00:00`)
      const diasJanela = this.regraDiasPorFiltro[this.selectedFilter] || 0
      const dataCalculada = new Date(fim)
      dataCalculada.setDate(dataCalculada.getDate() - diasJanela)
      const y = dataCalculada.getFullYear()
      const m = String(dataCalculada.getMonth() + 1).padStart(2, '0')
      const d = String(dataCalculada.getDate()).padStart(2, '0')
      this.atendimentoData = `${y}-${m}-${d}`
    },

    /**
     * Emite o filtro de atendimento selecionado.
     */
    emitirFiltro() {
      this.$emit('update-filtro-atendimento', {
        filtro: this.selectedFilter,
        operador: this.atendimentoOperador,
        data: this.atendimentoData,
      })
    },

    /**
     * Retorna a data do último registro sincronizado por indicador.
     * @param {Number} idSinc Identificador da sincronização
     * @returns {String} Data do último registro
     */
    dtUltimoRegistroIdSinc(idSinc) {
      const registro =
        this.$store.getters.getUltimoRegistroTabelaSincronizadaPorIndicador(
          idSinc
        )

      if (!registro?.dt_ultimo_registro) return ''

      return registro.dt_ultimo_registro
    },

    /**
     * Converte um texto para letras maiúsculas.
     * @param {String} str Texto de entrada
     * @returns {String} Texto em maiúsculo
     */
    toUpper(str) {
      return (str || '').toString().toUpperCase()
    },

    /**
     * Converte uma data do formato YYYY-MM-DD para DD/MM/YYYY.
     * @param {String} yyyy_mm_dd Data no formato ISO
     * @returns {String} Data formatada
     */
    formatDateBR(yyyy_mm_dd) {
      if (!yyyy_mm_dd) return ''
      const [y, m, d] = yyyy_mm_dd.split('-')
      return `${d}/${m}/${y}`
    },

    /**
     * Formata um CPF para o padrão de exibição.
     * @param {String|Number} cpf CPF a ser formatado
     * @returns {String} CPF formatado
     */
    formatCPF(cpf) {
      const s = (cpf || '').toString().replace(/\D/g, '').padStart(11, '0')
      return `${s.substr(0, 3)}.${s.substr(3, 3)}.${s.substr(6, 3)}-${s.substr(
        9,
        2
      )}`
    },

    /**
     * Formata um CNS com espaçamento para exibição.
     * @param {String|Number} cns CNS a ser formatado
     * @returns {String} CNS formatado
     */
    formatCNSSpaced(cns) {
      const s = (cns || '').toString().replace(/\D/g, '').padStart(15, '0')
      return `${s.substr(0, 3)} ${s.substr(3, 4)} ${s.substr(7, 4)} ${s.substr(
        11,
        4
      )}`
    },

    /**
     * Gera a imagem PNG de um código de barras.
     * @param {String|Number} code Código a ser convertido
     * @returns {String} Imagem em base64
     */
    makeBarcodePNG(code) {
      const canvas = document.createElement('canvas')
      JsBarcode(canvas, (code || '').toString(), {
        format: 'CODE128',
        displayValue: false,
        height: 40,
        margin: 0,
      })
      return canvas.toDataURL('image/png')
    },

    /**
     * Gera o cartão nacional de saúde do cidadão
     */
    imprimirCNS() {
      const c = this.cidadao
      if (!c) return

      const nome = this.toUpper(c.no_cidadao)
      const sexo = c.sexo === 'FEMININO' ? 'F' : 'M'
      const prefixo = sexo === 'F' ? 'Sra. ' : 'Sr. '
      const dataNasc = this.formatDateBR(c.dt_nascimento)
      const cpfMask = c.nu_cpf != null ? this.formatCPF(c.nu_cpf) : ''
      const cnsRaw = (c.nu_cns || '').toString()
      const cnsView = this.formatCNSSpaced(cnsRaw)

      const doc = new jsPDF({ orientation: 'p', unit: 'mm', format: 'a4' })

      // Título
      doc.setFont('helvetica', 'bold')
      doc.setFontSize(16)
      doc.text('Cartão Nacional de Saúde - CNS', 105, 20, { align: 'center' })

      // Mensagens
      doc.setFont('helvetica', 'normal')
      doc.setFontSize(12)
      doc.text(`${prefixo}${this.toUpper(c.no_cidadao)},`, 10, 30)
      doc.text(
        'Parabéns! Seus dados já constam no Sistema Único de Saúde - SUS',
        10,
        36
      )
      doc.text(
        'Informe, seu número de CNS quando usar a rede do Sistema Único de Saúde – SUS.',
        10,
        42
      )
      doc.text(
        'Recorte o Cartão abaixo e use-o normalmente. Ele vale em todo o território nacional.',
        10,
        48
      )

      try {
        doc.addImage(templateCartao, 'PNG', 10, 60, 190, 70)
      } catch (e) {}

      // Frente
      doc.setFont('helvetica', 'normal')
      doc.setTextColor(255, 255, 255)
      doc.setFontSize(7)
      if (nome.length > 33) {
        this._multiLineText(doc, nome, 25, 107, 55, 3)
        // CPF
        doc.setFont('helvetica', 'bold')
        doc.setFontSize(15)
        doc.text(cpfMask, 25, 117)
      } else {
        this._multiLineText(doc, nome, 25, 110, 65, 4)
        doc.setFont('helvetica', 'bold')
        doc.setFontSize(15)
        doc.text(cpfMask, 25, 117)
      }

      // Verso
      doc.setTextColor(0, 0, 0)
      doc.setFont('helvetica', 'bold')
      doc.setFontSize(7)
      this._multiLineText(doc, nome, 120, 80, 60, 3, 'left')
      if (c.nu_cns) {
        const barcode = this.makeBarcodePNG(cnsRaw)

        if (nome.length > 38) {
          doc.setFont('helvetica', 'bold')
          doc.setFontSize(7)
          doc.text(`Data Nasc.: ${dataNasc}`, 120, 88)
          doc.text(`Sexo: ${sexo}`, 160, 88)

          doc.setFont('helvetica', 'bold')
          doc.setFontSize(18)
          doc.text(cnsView, 120, 95)

          // só adiciona se tiver CNS
          doc.addImage(barcode, 'PNG', 121, 98, 59, 8)
        } else {
          doc.setFont('helvetica', 'bold')
          doc.setFontSize(7)
          doc.text(`Data Nasc.: ${dataNasc}`, 120, 85)
          doc.text(`Sexo: ${sexo}`, 160, 85)

          doc.setFont('helvetica', 'bold')
          doc.setFontSize(18)
          doc.text(cnsView, 120, 94)

          // só adiciona se tiver CNS
          doc.addImage(barcode, 'PNG', 121, 97, 59, 8)
        }
      } else {
        if (nome.length > 38) {
          doc.setFontSize(7)
          doc.text(`Data Nasc.: ${dataNasc}`, 120, 88)
          doc.text(`Sexo: ${sexo}`, 160, 88)
        } else {
          doc.setFontSize(7)
          doc.text(`Data Nasc.: ${dataNasc}`, 120, 85)
          doc.text(`Sexo: ${sexo}`, 160, 85)
        }
      }

      doc.save(`cns_${cnsRaw || ''}.pdf`)
    },

    /**
     * Quebra e imprime o texto em múltiplas linhas.
     * @param {Object} doc Instância do jsPDF
     * @param {String} text Texto a ser impresso
     * @param {Number} x Posição horizontal inicial
     * @param {Number} y Posição vertical inicial
     * @param {Number} maxWidth Largura máxima da linha
     * @param {Number} lineHeight Altura entre linhas
     * @param {String} align Alinhamento do texto
     */
    _multiLineText(doc, text, x, y, maxWidth, lineHeight, align = 'left') {
      if (!text) return
      const words = text.split(' ')
      let line = ''
      let cursorY = y

      words.forEach((w, idx) => {
        const test = line ? `${line} ${w}` : w
        const wTest = doc.getTextWidth(test)
        if (wTest > maxWidth) {
          // imprime a linha anterior
          doc.text(line, x, cursorY, { align })
          line = w
          cursorY += lineHeight
        } else {
          line = test
        }
        // final
        if (idx === words.length - 1 && line) {
          doc.text(line, x, cursorY, { align })
        }
      })
    },

    /**
     * Retorna a situação cadastral atual do cidadão.
     * @returns {String} Situação do cadastro
     */
    situacaoCadastro() {
      if (this.cidadao.dt_obito != null) {
        return 'Óbito'
      }
      if (this.cidadao.dt_obito == null && this.cidadao.ativo_territorio == 1) {
        return 'Ativo'
      }
      if (this.cidadao.dt_obito == null && this.cidadao.ativo_territorio == 0) {
        return 'Desatualizado'
      }
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
.header-card-info-span {
  background: #c4e8f6;
  color: #00aeef;
  padding: 5px 10px;
  border-radius: 10px;
  font-size: 14px;
  margin-left: 5px;
  &.red {
    background: #ffb3b3;
    color: red;
  }
  &.green {
    background: #00e600;
    color: green;
  }
}

.bubble-logo {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: #e6f4ff;
  color: #2b6cb0;
  border: 1px solid #cfe8ff;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 6px;
  line-height: 1;
  span {
    i {
      font-size: 30px;
    }
  }
}

.text-muted {
  span {
    background: #c4e8f6;
    color: #00aeef;
    padding: 5px 10px;
    border-radius: 10px;
    font-size: 14px;
    margin-left: 5px;
  }
}

.btn-imprimir-cns {
  background-color: green;
  border: none;
  border-radius: 12px;
  text-transform: initial;
}
</style>
